import { render, staticRenderFns } from "./ClosePendingFlagPopup.vue?vue&type=template&id=faf092c8&scoped=true&"
import script from "./ClosePendingFlagPopup.vue?vue&type=script&lang=js&"
export * from "./ClosePendingFlagPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf092c8",
  null
  
)

export default component.exports